module.exports = __webpack_public_path__ + "static/media/polar-bear.c78bc0f8.svg";